import React, { useState, useCallback, useContext, useEffect } from "react";
import styled from "styled-components";
import EditPic from "../../../SVGs/Edit.svg";
import CustomTextField from "../../Common/CustomTextField";
import TrainingPrograms from "../../Common/TrainingPrograms";
import NonTrainingPrograms from "../../Common/NonTrainingPrograms";
import IncomeSource from "../../Common/IncomeSource";
import toast from "react-hot-toast";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../../server/get_api_client";
import Cookies from "js-cookie";
import { UserContext } from "../../../Context/user_context";
import PageLoader from "../../Common/PageLoader";
import { useScreenWidth } from "../../../helper/screentWidth";

function EmploymentInformation({
  data,
  contactId,
  refetchData,
  employmentPass,
  submitPass,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [employemntInfomration, setEmployemntInfomration] = useState(false);
  const { user, setUser } = useContext(UserContext);
  const screenWidth = useScreenWidth();

  const [residencyCompletion, setResidencyCompletion] = useState(
    data && data.new_trainingcompletion
      ? data.new_trainingcompletion.split("T")[0]
      : null
  );
  const [fellowshipCompletion, setFellowshipCompletion] = useState(
    data && data.new_trainingcompletedf
      ? data.new_trainingcompletedf.split("T")[0]
      : null
  );
  const [fellowship, setFellowsihp] = useState(
    data ? data._hip_fellowshipspecialtyid_value : null
  );
  const [residency, setResidency] = useState(
    data ? data._hip_residencyspecialtyid_value : null
  );
  const [companyGroup, setCompanyGroup] = useState(
    data ? data._hip_companygroup_value : null
  );
  const [companyGroupName, setCompanyGroupName] = useState(
    data
      ? data[
          "_hip_companygroup_value@OData.Community.Display.V1.FormattedValue"
        ]
      : ""
  );
  const [companyGroupText, setCompanyGroupText] = useState(
    data ? data.hip_companygrouptext : ""
  );
  const [isCustomCompanyGroup, setIsCustomCompanyGroup] = useState(
    data
      ? Boolean(data.hip_companygrouptext && !data._hip_companygroup_value)
      : false
  );

  const [incomeSource, setIncomeSource] = useState(
    data && data.hip_incomesource ? data.hip_incomesource : ""
  );

  // const [employerName, setEmployerName] = useState(
  //   data ? data.employerName : ""
  // );
  // const [dateStarted, setDateStarted] = useState("");
  // const [selfEmployed, setSelfEmployed] = useState("");

  const [netWorth, setNetWorth] = useState(data ? data.new_networth : "");
  const [jobTitle, setJobTitle] = useState(data ? data.jobtitle : "");
  const [annualIncome, setAnnualIncome] = useState(
    data ? data.annualincome : ""
  );

  const handleEmployemntInfomration = useCallback(() => {
    setEmployemntInfomration(!employemntInfomration);
  }, [employemntInfomration]);

  useEffect(() => {
    setEmployemntInfomration(employmentPass);
  }, [employmentPass]);

  const handleUpdateRecord = async () => {
    setIsLoading(true);
    const userid = contactId
      ? contactId
      : Cookies.get("hippocratic_portal_contactid");
    const recordData = {
      entity: "contacts",
      id: userid,
      attributes: [
        {
          fieldname: "hip_ResidencySpecialtyId",
          value: residency,
          type: "lookup",
          entity: "accounts",
        },
        ...(isCustomCompanyGroup
          ? [
              {
                fieldname: "hip_companygrouptext",
                value: companyGroupText,
                type: "string",
                entity: null,
              },
            ]
          : [
              {
                fieldname: "hip_CompanyGroup",
                value: companyGroup,
                type: "lookup",
                entity: "accounts",
              },
            ]),
        {
          fieldname: "hip_FellowshipSpecialtyId",
          value: fellowship,
          type: "lookup",
          entity: "accounts",
        },
        {
          fieldname: "new_trainingcompletion",
          value: residencyCompletion,
          type: "datetime",
          entity: null,
        },
        {
          fieldname: "new_trainingcompletedf",
          value: fellowshipCompletion,
          type: "datetime",
          entity: null,
        },
        {
          fieldname: "hip_incomesource",
          value: incomeSource,
          type: "optionset",
          entity: null,
        },
        {
          fieldname: "new_networth",
          value: netWorth,
          type: "int",
          entity: null,
        },
        {
          fieldname: "jobtitle",
          value: jobTitle,
          type: "string",
          entity: null,
        },
        {
          fieldname: "annualincome",
          value: annualIncome,
          type: "int",
          entity: null,
        },
        ...(user.hip_initialportalinfoupdate
          ? []
          : [
              {
                fieldname: "hip_initialportalinfoupdate",
                value: "910310000",
                type: "optionset",
                entity: null,
              },
            ]),
      ],
    };

    try {
      await getApiClient().updateRecord(recordData);
      if (!user.hip_initialportalinfoupdate) {
        setUser({
          ...user,
          hip_initialportalinfoupdate: true,
        });
      }
      if (!submitPass) {
        toast.success("Information has been updated successfully");
      }
      // Refetch data to get updated information
      if (refetchData) {
        await refetchData();
      }
    } catch (error) {
      makeStandardApiErrorHandler((error) => toast.error(error));
    } finally {
      setEmployemntInfomration(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    console.log(
      residency,
      fellowship,
      fellowshipCompletion,
      residencyCompletion,
      "residency, fellowship, fellowshipCompletion, residencyCompletion"
    );
    if (
      submitPass &&
      (residency || fellowship || fellowshipCompletion || residencyCompletion)
    ) {
      handleUpdateRecord();
    }
  }, [submitPass]);

  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Sectoin>
        <TopPart>
          <SubTitle>Employment Information</SubTitle>
          {employmentPass ? null : employemntInfomration ? (
            <Save onClick={handleUpdateRecord}>Save Changes</Save>
          ) : (
            <Edit
              onClick={() => {
                handleEmployemntInfomration();
              }}
            >
              Edit
              <img style={{ height: "19px" }} src={EditPic} alt="edit-icon" />
            </Edit>
          )}
        </TopPart>
        {screenWidth >= 690 ? (
          <BottomPart>
            <FieldsContainer>
              {data && data.new_title === 100000000 && (
                <>
                  <CustomTextField
                    Active={employemntInfomration}
                    Title="Residency Completion:"
                    value={residencyCompletion}
                    Type={"date"}
                    onChange={setResidencyCompletion}
                  />
                  <CustomTextField
                    Active={employemntInfomration}
                    Title="Fellowship Completion:"
                    value={fellowshipCompletion}
                    Type={"date"}
                    onChange={setFellowshipCompletion}
                  />
                </>
              )}
              <IncomeSource
                Active={employemntInfomration}
                value={incomeSource}
                onChange={setIncomeSource}
              />
              {data && data.new_title != 100000000 && (
                <CustomTextField
                  Active={employemntInfomration}
                  Title="Net Worth:"
                  value={netWorth}
                  currency={true}
                  onChange={setNetWorth}
                />
              )}
            </FieldsContainer>
            <FieldsContainer>
              {data && data.new_title === 100000000 && (
                <>
                  <TrainingPrograms
                    Active={employemntInfomration}
                    value={residency}
                    Title="Residency Program"
                    type={591930000}
                    onChange={setResidency}
                  />
                  <TrainingPrograms
                    Active={employemntInfomration}
                    value={fellowship}
                    Title="Fellowship Program"
                    type={591930001}
                    onChange={setFellowsihp}
                  />
                </>
              )}
              <NonTrainingPrograms
                Active={employemntInfomration}
                value={companyGroup}
                valueName={companyGroupName}
                Title="Company/Group"
                onChange={setCompanyGroup}
                textValue={companyGroupText}
                onTextChange={setCompanyGroupText}
                isCustom={isCustomCompanyGroup}
                onCustomToggle={setIsCustomCompanyGroup}
              />
              {(data && data.new_title) != 100000000 && (
                <CustomTextField
                  Active={employemntInfomration}
                  Title="Annual Income:"
                  currency={true}
                  value={annualIncome}
                  onChange={setAnnualIncome}
                />
              )}
              {/* <CustomTextField
              Active={employemntInfomration}
              Title="Date Started:"
              Type={"date"}
              value={dateStarted}
              onChange={setDateStarted}
            /> */}
            </FieldsContainer>
            <FieldsContainer>
              <CustomTextField
                Active={employemntInfomration}
                Title="Job Title:"
                value={jobTitle}
                onChange={setJobTitle}
              />
              {data && data.new_title === 100000000 && (
                <>
                  <CustomTextField
                    Active={employemntInfomration}
                    Title="Net Worth:"
                    value={netWorth}
                    currency={true}
                    onChange={setNetWorth}
                  />
                  <CustomTextField
                    Active={employemntInfomration}
                    Title="Annual Income:"
                    currency={true}
                    value={annualIncome}
                    onChange={setAnnualIncome}
                  />
                </>
              )}
            </FieldsContainer>
          </BottomPart>
        ) : (
          <BottomPart>
            <FieldsContainer>
              {data && data.new_title === 100000000 && (
                <>
                  <TrainingPrograms
                    Active={employemntInfomration}
                    value={residency}
                    Title="Residency Program"
                    type={591930000}
                    onChange={setResidency}
                  />
                  <CustomTextField
                    Active={employemntInfomration}
                    Title="Residency Completion:"
                    value={residencyCompletion}
                    Type={"date"}
                    onChange={setResidencyCompletion}
                  />
                  <TrainingPrograms
                    Active={employemntInfomration}
                    value={fellowship}
                    Title="Fellowship Program"
                    type={591930001}
                    onChange={setFellowsihp}
                  />
                  <CustomTextField
                    Active={employemntInfomration}
                    Title="Fellowship Completion:"
                    value={fellowshipCompletion}
                    Type={"date"}
                    onChange={setFellowshipCompletion}
                  />
                </>
              )}
              <CustomTextField
                Active={employemntInfomration}
                Title="Job Title:"
                value={jobTitle}
                onChange={setJobTitle}
              />
              <NonTrainingPrograms
                Active={employemntInfomration}
                value={companyGroup}
                valueName={companyGroupName}
                Title="Company/Group"
                onChange={setCompanyGroup}
                textValue={companyGroupText}
                onTextChange={setCompanyGroupText}
                isCustom={isCustomCompanyGroup}
                onCustomToggle={setIsCustomCompanyGroup}
              />
              <IncomeSource
                Active={employemntInfomration}
                value={incomeSource}
                onChange={setIncomeSource}
              />

              <CustomTextField
                Active={employemntInfomration}
                Title="Annual Income:"
                currency={true}
                value={annualIncome}
                onChange={setAnnualIncome}
              />
              <CustomTextField
                Active={employemntInfomration}
                Title="Net Worth:"
                value={netWorth}
                currency={true}
                onChange={setNetWorth}
              />
            </FieldsContainer>
          </BottomPart>
        )}
      </Sectoin>
    </>
  );
}

const Sectoin = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  align-items: flex-start;
  justify-content: center;
`;

const TopPart = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const Edit = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #87a9bf;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: italic;
  font-weight: 300;
  line-height: 10px;
  text-decoration-line: underline;
`;

const BottomPart = styled.div`
  display: grid;
  min-height: 100px;
  gap: 30px;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  justify-items: center;

  @media screen and (max-width: 450px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
`;

const SubTitle = styled.div`
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px;
`;

const FieldsContainer = styled.div`
  display: flex;
  gap: 5px;
  width: 100%;
  height: 100%;
  align-items: flex-end;
  flex-direction: column;
`;

const Save = styled.div`
  display: flex;
  align-items; center;
  justify-content: center;
  border-radius: 300px;
  background: #304961;
  padding: 5px 10px;

  cursor: pointer;

  white-space: nowrap;

  color: #fff;
  text-align: center;
  font-family: "Museo Sans Cyrl";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
`;

export default EmploymentInformation;
